import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { FlowMapItem, LibrarySliceState } from './library.type';

const libraryInitialState: LibrarySliceState = {
    flowMap: {},
};

export const LIBRARY_REDUCER_NAME = 'library';

export const librarySlice = createSlice({
    name: LIBRARY_REDUCER_NAME,
    initialState: libraryInitialState,
    reducers: {
        setFlowsByReelCode: (
            state,
            action: PayloadAction<{
                reelCode: string;
                flows: FlowMapItem[];
            }>,
        ) => {
            state.flowMap[action.payload.reelCode] = action.payload.flows;
        },
    },
});

export const { setFlowsByReelCode } = librarySlice.actions;

export const libraryReducer = librarySlice.reducer;
